import { render } from "./Mikomi_Month.vue?vue&type=template&id=3651f5dc"
import script from "./Mikomi_Month.vue?vue&type=script&lang=js"
export * from "./Mikomi_Month.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__